<template>
  <div class="offer-type-card" v-if="ofertaShow">
    <div class="offer-type-card__thumbnail">
      <div
        class="offer-type-card__price-label"
        :class="getNazwa()"
        v-show="cenaShow"
      >
        <span class="d-block">cena od</span>
        <span class="font-m font-22">{{ getCenaOd() }}</span>
        <span> zł/os.</span>
      </div>
      <img
        @error="onImageError"
        @load="hideLoader"
        :src="getImgUrl()"
        :alt="getTitle()"
      />
      <span class="image-loader">
        <loading-spinner :size="24" />
      </span>
    </div>
    <div class="offer-type-card__content">
      <div class="mb-6">
        <h4 class="font-20">{{ getTitle() }}</h4>
        <p v-html="getOpis()"></p>
      </div>
      <div class="mb-12 mt-auto text-center">
        <a :href="getZestUrl()" class="btn btn-md btn-d-blue"
          >Przeglądaj oferty</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as CONFIG from "../config.js";

export default {
  props: {
    oferta: Object,
    cena: Object,
  },
  data: () => ({
    imageLoaded: false,
    cenaShow: true,
    ofertaShow: true,
  }),
  methods: {
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
    onImageError(e) {
      e.target.src = "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    getCenaOd() {
      if (
        this.cena &&
        typeof this.cena.cenamin === "string" &&
        this.cena.cenamin != ""
      ) {
        this.ofertaShow = true;
        return this.cena.cenamin;
      } else {
        this.ofertaShow = false;
        return "";
      }
      /*this.ofertaShow = true;
      return this.cena.cenamin;*/
    },
    getImgUrl() {
      return (
        "https://www." + CONFIG.serwis + "/photo/grupa/" + this.oferta.zdjecie
      );
    },
    getTitle() {
      return this.oferta.child.snazwa;
    },
    getOpis() {
      return this.oferta.child.tekstzb;
    },
    getNazwa() {
      return this.oferta.child.nazwa;
    },
    getZestUrl() {
      //let prefixString = this.oferta.child.prefix.replace(/=/g, "-");
      var ind = this.oferta.child.parametry.indexOf("?");
      if (this.oferta.url.indexOf("autokar") !== -1) {
        return (
          this.oferta.url +
          "?" +
          this.oferta.child.parametry.substring(ind + 1)
        );
      } else {
        if (this.oferta.child.parametry.indexOf("pobyt=") != -1) {
          return (
            this.oferta.url +
            "?" +
            this.oferta.child.parametry.substring(ind + 1)
          );
        } else {
          return (
            this.oferta.url +
            "?" +
            this.oferta.child.parametry.substring(ind + 1)
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-type-card {
  background-color: #fff;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &__thumbnail {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    height: 198px;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }
  }

  &__price-label {
    background-color: rgba(darkmagenta, 0.82);
    border-bottom-right-radius: 20px;
    color: #fff;
    padding: 5px 16px 5px 12px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
  }

  &__content {
    border-color: $border-color;
    border-style: solid;
    border-width: 0 1px 1px;
    border-radius: 0 0 3px 3px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 12px 16px;
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
